module.exports = __webpack_public_path__ + "static/media/mosfet-board-2-compressed.3b218e73.jpg";